/**
 * Splits ids into runs of at most `size`, for an endpoint that refuses more
 * per request. An empty list is no batches, so the caller sends nothing.
 *
 * @param {string[]} ids
 * @param {number} size
 * @returns {string[][]}
 */
export const toBatches = (ids, size) => {
  const batches = [];
  for (let start = 0; start < ids.length; start += size) {
    batches.push(ids.slice(start, start + size));
  }

  return batches;
};
